// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnimatedArrowPair_wrapper__q0bic","base":"AnimatedArrowPair_base__aMH34","hover":"AnimatedArrowPair_hover__r2BDc"};